'use client';
import React from 'react';

import { usePathname } from 'next/navigation';
import { createGlobalStyle } from 'styled-components';

// define a GlobalStyle that only applies when hideChat=true
const ChatHider = createGlobalStyle<{ hideChat: boolean }>`
  #chat-widget-container {
    display: ${({ hideChat }) => (hideChat ? 'none' : 'block')};    
  }
`;

export default function HideChatWidget() {
  const [hideChat, setHideChat] = React.useState(false);
  const pathname = usePathname();

  React.useEffect(() => {
    // alert(pathname);

    const shouldHideChat = pathname.includes('/guide/');

    setHideChat(shouldHideChat);
  }, [pathname]);

  return <ChatHider hideChat={hideChat} />;
}
